// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PurchaseLimitsModal/style.css
// module id = 1989
// module chunks = 0